import * as React from 'react';
import { cn } from '../../lib/utils';
import { Label } from './label';

function FormField({ id, label, description, error, className, children }) {
  const hasError = Boolean(error);
  return (
    <div
      className={cn(
        'form-card tw-flex tw-flex-col tw-gap-2 tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-5 tw-shadow-sm tw-transition-colors dark:tw-border-slate-700 dark:tw-bg-slate-900',
        hasError &&
          'tw-border-red-300 tw-shadow-red-100 dark:tw-border-red-600/70 dark:tw-shadow-none',
        className,
      )}
    >
      <Label
        htmlFor={id}
        className={cn(
          'tw-text-xs tw-uppercase tw-tracking-wide tw-text-slate-500 dark:tw-text-slate-400',
          hasError && 'tw-text-red-600 dark:tw-text-red-400',
        )}
      >
        {label}
      </Label>
      {children}
      {description && (
        <p
          className={cn(
            'tw-text-xs tw-text-slate-400 dark:tw-text-slate-500',
            hasError && 'tw-text-red-600 dark:tw-text-red-400',
          )}
        >
          {description}
        </p>
      )}
      {hasError && (
        <p className="tw-text-xs tw-font-medium tw-text-red-600 dark:tw-text-red-400">{error}</p>
      )}
    </div>
  );
}

export { FormField };
